import { errorImage } from '@/globals/globals'
import { CarMake, CarModel } from '@/types/car'
import { AspectRatio, Heading, LinkBox, LinkOverlay } from '@chakra-ui/react'
import NextImage from 'next/legacy/image'
import NextLink from 'next/link'

type Props = {
  entry: CarMake | CarModel
}

const makeURL = (entry: any) => {
  if (!entry) return null
  if ('id_car_make' in entry) {
    return `/nation/categories/make/${entry.id_car_make}`
  }
  return `/nation/categories/model/${entry.id_car_model}`
}

export const CarMakeCard = ({ entry }: Props): JSX.Element => {
  const url = makeURL(entry)

  return (
    <LinkBox pos='relative'>
      <AspectRatio ratio={600 / 150}>
        <NextImage
          alt={entry.name}
          height='150'
          objectFit='cover'
          objectPosition='center'
          src={
            entry.memberProjects[0]?.images &&
            entry.memberProjects[0].images.length > 0
              ? `${entry.memberProjects[0]['images'][0]?.path}`
              : errorImage
          }
          width='600'
          layout='fill'
        />
      </AspectRatio>
      <NextLink href={url ?? '#'} passHref legacyBehavior>
        <LinkOverlay
          opacity={0.85}
          _hover={{ opacity: '.5' }}
          transitionDuration='1'
          transitionProperty='opacity'
          transitionTimingFunction='ease'>
          <Heading
            as='h2'
            fontSize='2xl'
            backgroundColor='black'
            color='white'
            p={4}
            pos='absolute'
            inset={0}>
            {entry.name}
          </Heading>
        </LinkOverlay>
      </NextLink>
    </LinkBox>
  )
}
